module.exports = __webpack_public_path__ + "static/media/close.b6f3e83e.png";